module.exports = __webpack_public_path__ + "static/media/common-interview-question.1a67755e.jpg";